var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHappyFace = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#3863F0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.193 8.381h-6.385c-2.774 0-4.427 1.654-4.427 4.427v6.377c0 2.781 1.653 4.434 4.427 4.434h6.377c2.773 0 4.427-1.653 4.427-4.426v-6.385c.007-2.773-1.646-4.427-4.42-4.427Zm-5.86 3.337c.785 0 1.433.64 1.433 1.433a1.43 1.43 0 0 1-1.432 1.432 1.442 1.442 0 0 1-1.433-1.44c0-.785.648-1.425 1.433-1.425ZM16 21.395a3.723 3.723 0 0 1-3.718-3.718c0-.534.434-.976.968-.976h5.485a.97.97 0 0 1 .968.976A3.7 3.7 0 0 1 16 21.395Zm2.667-6.827c-.785 0-1.433-.64-1.433-1.432 0-.793.64-1.433 1.433-1.433.792 0 1.432.64 1.432 1.433 0 .792-.647 1.432-1.432 1.432Z"
})));
export default SvgHappyFace;